import { EntityRequestCostsacct } from "../../entity/EntityRequestCostsacct";

export class DtoRequestCostsacctsDeleteRes extends EntityRequestCostsacct {
  public message: string | null = null;
}
